import { gql } from '@apollo/client';

export const GET_USERS = gql`
  query GetUsers {
    users {
      id
      username
      email
      passwordHash
      role
      profilePicture
      phoneNumber
      status
      lastLogin
      twoFactorEnabled
      gender
      createdAt
      updatedAt
    }
  }
`;


export const GET_VENDOR_BY_USER_ID = gql`
  query GetVendorByUserId($userId: ID!) {
    getVendorByUserId(userId: $userId) {
      id
      businessName
      email
      phone
      address
      panno
      gstno
      userId
    }
  }
`;


export const GET_SHOP_BY_VENDOR_ID = gql`
  query GetShopByVendorId($vendorId: ID!) {
    getShopByVendorId(vendorId: $vendorId) {
      id
      vendorId
      shopName
      shopLogo
      rating
      reviewsCount
      followers
      location {
        city
        state
        country
      }
      fromDate
      toDate
      createdAt
    }
  }
`;


export const GET_TOP_SHOPS = gql`
  query GetTopShops($limit: Int) {
    getTopShops(limit: $limit) {
      id
      shopLogo
      shopName
      rating
      createdAt
      location {
        city
        country
        state
      }
    }
  }
`;
export const GET_ALL_ORDERS_QUERY = gql`
  query {
    getAllOrders {
      id
      status
      userId
      paymentId
      totalAmount
      orderType
      paymentYN
      addressId
      createdAt
      items {
        id
        productId
        quantity
        price
      }
    }
  }
`;


export const GET_ALL_ORDERS_USERID_QUERY = gql`
  query GetOrders($userId: ID!) {
    getOrders(userId: $userId) {
      id
      status
      userId
      paymentId
      totalAmount
      orderType
      paymentYN
      createdAt
      addressId
      items {
        id
        productId
        quantity
        price
      }
    }
  }
`;


export const GET_ALL_PRODUCTS_QUERY = gql`
  query GetAllProducts{
    products {
      id
      name
      slug
      description
      currency
      categoryId
      price
      stockQuantity
      images
      discountedPrice
      vendorId
      shopId
      status
      marginPrice
      gst
      rewardFlag
      attributes {
        key
        value
      }
      variants {
        price
        stockQuantity
        properties {
          key
          value
        }
      }
    }
  }
`;

export const GET_ALL_COUNTS_QUERY = gql`
  query {
  vendors {
    id
  }
  shops {
    id
  }
  categories {
    id
  }
  products {
    id
  }
}

`;


export const GET_USERS_AND_ORDERS = gql`
  query DashboardData {
    users {
      id
      username
      email
      role
      profilePicture
      status
    }
    getAllOrders {
      id
      userId
      totalAmount
      status
      createdAt
      paymentYN
      orderType
      addressId
      items {
        id
        orderId
        productId
        quantity
        price
      }
    }
  }
`;


export const GET_USER_AND_ORDERS = gql`
  query DashboardData($userId: ID!) {
    user(id: $userId) {
      id
      username
      email
      role
      profilePicture
      status
      gender
    }
    getOrders(userId: $userId) { 
      id
      userId
      totalAmount
      status
      createdAt
      paymentYN
      orderType
      items {
        id
        orderId
        productId
        quantity
        price
      }
    }
  }
`;




export const CREATE_PRODUCT_MUTATION = gql`
  mutation CreateProduct($input: NewProduct!) {
    createProduct(input: $input) {
      name
      slug
      description
      price
      discountedPrice
      gst
      currency
      stockQuantity
      categoryId
      vendorId
      shopId
      images
      status
      marginPrice
      rewardFlag
      attributes {
        key
        value
      }
      variants {
        price
        stockQuantity
        properties {
          key
          value
        }
      }
    }
  }
`;

export const UPDATE_PRODUCT_MUTATION = gql`
  mutation UpdateProduct($id: ID!, $input: UpdateProductInput!) {
    updateProduct(id: $id, input: $input) {
      id
      name
      slug
      description
      price
      discountedPrice
      gst
      currency
      stockQuantity
      categoryId
      vendorId
      shopId
      images
      status
      marginPrice
      rewardFlag
      attributes {
        key
        value
      }
      variants {
        price
        stockQuantity
        properties {
          key
          value
        }
      }
    }
  }
`;



export const DELETE_PRODUCT_MUTATION = gql`
  mutation DeleteProduct($id: ID!) {
    deleteProduct(id: $id)
  }
`;

export const SAVE_SHOP_REWARD_CONFIG = gql`
  mutation SaveShopRewardConfig(
    $shopId: ID!
    $shopCommPct: Float!
    $custPct: Float!
  ) {
    saveShopRewardConfig(
      shopId: $shopId
      shopCommPct: $shopCommPct
      custPct: $custPct
    ) {
      shopId
      shopCommPct
      custPct
      lngNetPct
      isActive
    }
  }
`;


export const GET_ADDRESS_BY_ID = gql`
  query GetAddressByID($id: ID!) {
    address(id: $id) {
      id
      userId
      addressLine1
      addressLine2
      city
      state
      country
      postalCode
      isDefault
    }
  }
`;

export const GET_REWARD_DETAILS = gql`
  query getRewardDetails($userId: ID!) {
    getRewardDetails(userId: $userId) {
      userId
      walletBalance
      totalEarned
      totalUsed
      totalLoyaltyIds
      activeQueueEntries
    }
  }
`;